import { v4 as uuid } from 'uuid';
import {
    COURSE_MEASURE_FIELDS,
    type DescriptionCourse
} from '@ast-data/shared';

/** A Lage row in the editor — a DescriptionCourse plus a stable local key. */
export type CourseRow = DescriptionCourse & { id: string };

/** Wrap stored Lagen as editor rows (on open / reset). */
export function toCourseRows(
    courses: readonly DescriptionCourse[] | undefined
): CourseRow[] {
    return (courses ?? []).map((entry) => ({ id: uuid(), ...entry }));
}

/** Strip the local key + empty rows, leaving the storable list. */
export function cleanCourses(rows: readonly CourseRow[]): DescriptionCourse[] {
    return rows
        .map((row) => ({
            name: row.name.trim(),
            length: row.length.trim(),
            width: row.width.trim(),
            depth: row.depth.trim(),
            diameter: row.diameter.trim(),
            heightTop: row.heightTop.trim(),
            heightBottom: row.heightBottom.trim(),
            levelSheet: row.levelSheet.trim()
        }))
        .filter((entry) => Object.values(entry).some((field) => field !== ''));
}

/** Stable, order-sensitive key for the list (dirty comparison). */
export function coursesKey(rows: readonly DescriptionCourse[]): string {
    return JSON.stringify(
        rows.map((row) => [
            row.name.trim(),
            ...COURSE_MEASURE_FIELDS.map((field) => row[field].trim()),
            row.levelSheet.trim()
        ])
    );
}
